//import React from 'react'
import { connect } from 'react-redux'
import { setToken } from '../../modules/reducer'

import pathIntranet from '../../ruta'

import axios from 'axios'

const Token = ({ match, history, setToken }) => {
  axios({
    method: 'get',
    url: `${pathIntranet}/administracion/usuario-token?_format=json&token=${
      match.params.token
    }`,
    auth: {
      username: 'leeestancias1',
      password: 'ed3ok5Rd$2fkDdc'
    }
  })
    .then(function(response) {
      if (response.data.length > 0) {
        axios({
          method: 'get',
          url: `${pathIntranet}/administracion/usuario-configuraciones?_format=json&nid=${
            response.data[0].nid
          }`,
          auth: {
            username: 'leeestancias1',
            password: 'ed3ok5Rd$2fkDdc'
          }
        })
          .then(function(response1) {
            const configuraciones = response1.data.map(d => ({
              id: d.nid,
              estancias: JSON.parse(d.configuracion.replace(/&quot;/g, '"'))
            }))

            setToken({
              token: match.params.token,
              idUsuario: response.data[0].nid,
              configuraciones
            })
            history.push('/')
          })
          .catch(function(error) {
            console.log(error)
          })
      } else {
        history.push('/')
      }
    })
    .catch(function(error) {
      console.log(error)
    })

  return null
}

/*
const mapStateToProps = ({ reducer }, ownProps) => {
  const getO = getOpciones(ownProps.idEstanciaActual)
  const getS = getSubtotal(ownProps.idEstanciaActual)

  return ({ reducer }, ownProps) => {
    const endMenu = getEndMenu(reducer)
    return {
      estanciaTitle: getEstanciaActualTitle(reducer, ownProps.idEstanciaActual),
      acabados: getO(reducer),
      subtotal: getS(reducer),
      total: getTotal(reducer),
      subtotales: getSubtotales(reducer),
      showSlider: endMenu < 0
    }
  }
}
*/

const mapDispatchToProps = { setToken }

export default connect(
  null,
  mapDispatchToProps
)(Token)
